import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import AuthContext from '../context/AuthContext';
import SiteFooter from '../components/SiteFooter';

const NAVER_OAUTH_LOGIN = `${process.env.REACT_APP_API_URL || ''}/oauth/naver?mode=login`;

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || "/";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            await login(username, password);
            navigate(from, { replace: true });
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-page">
            {/* Left - Brand Panel */}
            <div className="login-brand-panel">
                <div className="login-brand-content">
                    <div className="login-brand-logo">W</div>
                    <h1 className="login-brand-title">WashNote</h1>
                    <p className="login-brand-subtitle">매장 관리의 새로운 기준</p>
                    <div className="login-brand-features">
                        <div className="login-brand-feature">
                            <span className="login-feature-dot" />
                            <span>실시간 워크보드로 작업 현황 한눈에</span>
                        </div>
                        <div className="login-brand-feature">
                            <span className="login-feature-dot" />
                            <span>매출·고객·재방문 통계 대시보드</span>
                        </div>
                        <div className="login-brand-feature">
                            <span className="login-feature-dot" />
                            <span>고객 관리와 차량 이력 추적</span>
                        </div>
                    </div>
                </div>
                <div className="login-brand-footer">
                    &copy; {new Date().getFullYear()} WashNote
                </div>
            </div>

            {/* Right - Form Panel */}
            <div className="login-form-panel">
                <div className="login-form-wrapper">
                    <div className="login-form-header">
                        <div className="login-mobile-logo">W</div>
                        <h2 className="login-form-title">로그인</h2>
                        <p className="login-form-desc">계정 정보를 입력해주세요</p>
                    </div>

                    <Button
                        variant="success"
                        className="login-submit"
                        style={{ marginBottom: 16, background: '#03C75A', borderColor: '#03C75A' }}
                        onClick={() => { window.location.href = NAVER_OAUTH_LOGIN; }}
                    >
                        네이버로 로그인
                    </Button>

                    <div style={{ textAlign: 'center', margin: '12px 0', color: '#999', fontSize: '0.85rem' }}>또는</div>

                    <Form onSubmit={handleSubmit} className="login-form">
                        {error && <Alert variant="danger" className="login-alert">{error}</Alert>}
                        <Form.Group className="login-field" controlId="username">
                            <Form.Label>아이디</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="아이디를 입력하세요"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoFocus
                                className="login-input"
                            />
                        </Form.Group>
                        <Form.Group className="login-field" controlId="password">
                            <Form.Label>비밀번호</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="비밀번호를 입력하세요"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="login-input"
                            />
                        </Form.Group>
                        <Button
                            variant="primary"
                            type="submit"
                            className="login-submit"
                            disabled={isLoading}
                        >
                            {isLoading ? '로그인 중...' : '로그인'}
                        </Button>
                    </Form>

                    <div style={{ textAlign: 'center', marginTop: 24, paddingTop: 16, borderTop: '1px solid #eee', fontSize: '0.95rem', color: '#666' }}>
                        아직 계정이 없으신가요?{' '}
                        <button
                            type="button"
                            onClick={() => navigate('/signup')}
                            style={{ color: '#1B73E8', background: 'none', border: 'none', padding: 0, cursor: 'pointer', textDecoration: 'underline' }}
                        >
                            회원가입하기
                        </button>
                    </div>
                    <SiteFooter />
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
